import Show from "./Show";
import Edit from "./Edit";

const Profile = {
    Show,
    Edit
};

export default Profile;